<template>
  <div id="app">
    <!-- 导航栏 - 只在登录后且不在登录页面时显示 -->
    <nav v-if="isLoggedIn && !isLoginPage" class="navbar">
      <div class="nav-container">
        <div class="nav-left">
          <router-link to="/" class="nav-link">文章对比</router-link>
          <router-link to="/edit" class="nav-link">文章编辑</router-link>
        </div>
        <div class="nav-right">
          <span class="user-info">{{ userInfo }}</span>
          <button @click="handleLogout" class="logout-btn">退出登录</button>
        </div>
      </div>
    </nav>
    
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import apiService from './api'

const router = useRouter()
const route = useRoute()

const isLoggedIn = computed(() => {
  return !!localStorage.getItem('token')
})

const isLoginPage = computed(() => {
  return route.path === '/login'
})

const userInfo = computed(() => {
  const token = localStorage.getItem('token')
  if (token) {
    try {
      // 解析 JWT token 获取用户信息
      const payload = JSON.parse(atob(token.split('.')[1]))
      return payload.full_name || payload.username || '用户'
    } catch (e) {
      return '用户'
    }
  }
  return ''
})

const handleLogout = () => {
  apiService.clearToken()
  router.push('/login')
}
</script>

<style>
#app {
  font-family: Arial, sans-serif;
}

.navbar {
  background: #fff;
  border-bottom: 1px solid #e1e5e9;
  padding: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 60px;
}

.nav-left {
  display: flex;
  gap: 20px;
}

.nav-link {
  color: #333;
  text-decoration: none;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.nav-link:hover {
  background-color: #f5f5f5;
}

.nav-link.router-link-active {
  color: #667eea;
  background-color: #f0f2ff;
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.user-info {
  color: #666;
  font-size: 14px;
}

.logout-btn {
  padding: 6px 12px;
  background-color: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.logout-btn:hover {
  background-color: #e8e8e8;
  color: #333;
}
</style>
